export default __webpack_public_path__ + "static/media/alert-white-icon.9ada7e76.png";